export default __webpack_public_path__ + "what.b7ae116ae14cafe6adfb9cfa119599c5.svg";